import React from 'react'
import { ImageCellStyles } from './Style'
import { Img } from 'styles/GlobalStyle'
import { Placeholder } from 'assets'
import { useDispatch } from 'react-redux'
import { actions } from 'store'
import { alerts } from 'keys'

const ImageCell = (props) => {
    const { cell } = props
    const value = cell.getValue()
    const dispatch = useDispatch()

    const handleImageClick = () => {
        dispatch(actions.setAlerts({ key: alerts.preview, value: { open: true, props: value, type: "img" } }))
    }

    return (
        <ImageCellStyles>
            {!value || <Img src={value} onClick={handleImageClick} />}
        </ImageCellStyles>
    )
}

export default ImageCell